<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { Toaster } from '@/components/ui/sonner'
import AdminLayout from '@/components/layout/AdminLayout.vue'
import ConfirmDialog from '@/components/common/ConfirmDialog.vue'
import { useNotificationSocket } from '@/features/notifications/composables/useNotificationSocket'

const route = useRoute()

useNotificationSocket()

const isBlankLayout = computed(() => (route.meta.layout as string | undefined) === 'blank')
</script>

<template>
  <AdminLayout v-if="!isBlankLayout" />
  <RouterView v-else />
  <Toaster position="top-right" />
  <ConfirmDialog />
</template>
